import {defineNuxtPlugin, useRuntimeConfig} from 'nuxt/app';

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig().public;
    const version = config.BUILD_VERSION as string;
    const commit = config.BUILD_COMMIT as string;
    const buildTime = config.BUILD_TIME as string;
    const env = config.ENVIRONMENT as string;

    const commitShort = commit.length > 7 ? commit.slice(0, 7) : commit;
    const parts = [`Codepresso ${version}`];
    if (commitShort && commitShort !== 'unknown') {
        parts.push(commitShort);
    }
    if (env !== 'opt') {
        parts.push(`(${env})`);
    }
    if (buildTime) {
        parts.push(`| built ${buildTime}`);
    }

    console.log(
        `%c${parts.join(' ')}`,
        'color: #6366f1; font-weight: bold;'
    );
});
